export const NEW_PARTICIPANT_KEY = 'new-participant';
